<template>
  <div class="resultsV2-style-segment" v-if="LeadershipStyles[props.style.leading_style]">
    <div class="resultsV2-style-description">
      <span class="resultsV2-style-description-title">Quel est votre style de leadership ?</span>
      <div class="resultsV2-style-description-subtitle">
        <span>
          En situation de leadership, vous avez tendance à adopter un style
          <span class="resultsV2-leadership-colour"> {{ style }}</span>.
        </span>
      </div>
      <div class="resultsV2-style-description-text"> {{ description }} </div>
      <div class="resultsV2-style-keys-segment">
        <div class="resultsV2-style-keys-back resultsV2-leadership-bg-colour" v-for="(keyword, index) in keywords"
          :key="index">
          <span class="resultsV2-style-keys-text">{{ keyword }} </span>
        </div>
      </div>
    </div>
    <div class="resultsV2-style-graph-area">
      <div class="resultsV2-style-box4-vertical resultsV2-style-box4-vertical"
        :class="{ 'resultsV2-leadership-bg-colour': index === props.style.leading_style }"
        v-for="(style, index) in enabledStyles"
        :key="index">
        <span class="resultsV2-style-box4-text"
          :class="{ 'resultsV2-style-box4-text-selected': index === props.style.leading_style }">
          {{ style.title }}
        </span>
      </div>
    </div>
  </div>
</template>

<style>
.resultsV2-style-graph-area {
  &> :first-child {
    border-radius: 6px 6px 0 0;
    border-top: 2px solid #464646 !important;
  }

  &> :last-child {
    border-radius: 0 0 6px 6px;
    border-bottom: 2px solid #464646 !important;
  }
}

.resultsV2-leadership-colour {
  color: #F679C9;
}

.resultsV2-leadership-bg-colour {
  background: linear-gradient(151.64deg, #FF97DA, #F164BF) !important;
}
</style>

<script setup lang="ts">
import { computed } from "vue";
import _ from "lodash";

import LeadershipStyles from "../../../assets/leadership_styles.json";

export interface LeadershipStyle {
  adaptability_badge: boolean;
  leading_style: string;
  categories: {
    laissez_faire: number;
    transactional: number;
    transformational: number;
  }
}

const props = defineProps<{
  style: LeadershipStyle;
}>();

const enabledStyles: Record<string, any> = computed(() => {
  return _.pickBy(LeadershipStyles, (style) => {
    return style.enabled === true;
  });
});

const description = computed(() => {
  return LeadershipStyles[props.style.leading_style].description;
});

const style = computed(() => {
  return LeadershipStyles[props.style.leading_style].style;
});

const keywords = computed(() => {
  return LeadershipStyles[props.style.leading_style].keywords;
});

</script>